const orgValidations = {
  name: (value) => value.length >= 3 && value.length <= 50,

  website: (value) => {
    const websitePattern =
      /(https:\/\/|http:\/\/)?(www\.)?((?!www)[a-zA-Z0-9]{3,})(\.[a-zA-Z0-9]{2,})/;
    return websitePattern.test(value);
  },

  date: (value) => value || 0,

  phone: (value) => {
    const phonePattern = /^[0-9]{6,12}$/;
    return phonePattern.test(value);
  },

  description: (value) => value.length >= 3 && value.length <= 500,

  email: (value) => {
    const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
    return emailPattern.test(value);
  },
};

export default orgValidations;
